var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "info-modal" },
      on: {
        click: function ($event) {
          _vm.show = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "info-box",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitContact.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "info-label" }, [
                _vm._v(_vm._s(_vm.$t("info.label"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "info-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("info.description")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "call-button", attrs: { type: "submit" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("info.submitButton")) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }